import {
  Component,
  AfterViewInit,
  Input,
  ViewChild,
  ElementRef,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-semi-circle-progress-bar',
  templateUrl: './semi-circle-progress-bar.component.html',
  styleUrls: ['./semi-circle-progress-bar.component.scss'],
})
export class SemiCircleProgressBarComponent implements OnInit, AfterViewInit {
  @Input() progress: number = 0;
  @Input() userData: { _id?: string } = {};
  @Input() staffer;
  @ViewChild('progressPath') progressPath!: ElementRef<SVGPathElement>;
  @ViewChild('shadowPath') shadowPath!: ElementRef<SVGPathElement>;

  id: string = '';
  interpolatedColor: string = '#00FF00';
  
  readonly gradientStops = [
  { offset: 0, color: '#FF0000' },     // 0–6
  { offset: 7.14, color: '#FF2400' },  // 7–13
  { offset: 14.28, color: '#FF4700' }, // 14–20
  { offset: 21.42, color: '#FF6B00' }, // 21–27
  { offset: 28.56, color: '#FF8F00' }, // 28–34
  { offset: 35.7, color: '#FFB200' },  // 35–41
  { offset: 42.84, color: '#FFD600' }, // 42–48
  { offset: 49.98, color: '#FFFA00' }, // 49–55
  { offset: 55, color: '#F5FF00' },    // smoothing before 60
  { offset: 60, color: '#E0FF00' },    // ✅ exactly 60%
  { offset: 66, color: '#BDFF00' },    // 63–69
  { offset: 71.4, color: '#99FF00' },  // 70–77
  { offset: 78.54, color: '#75FF00' }, // 78–84
  { offset: 85.68, color: '#52FF00' }, // 85–91
  { offset: 92.82, color: '#2EFF00' }, // 92–98
  { offset: 100, color: '#00FF00' },   // 99–100
];
  initProgress: number;


  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Generate unique ID for SVG elements
    this.id = this.userData?._id + '-' + Math.random().toString(36).substr(2, 9);
   
    //create clone for default values
    this.initProgress = this.progress;
    this.progress = Math.max(0, this.progress); // Clamp negative progress
    
    if(this.userData?.['shifts_completed'] === 0 && this.initProgress == 0) {
      return;
    }

    this.updateInterpolatedColor();
    this.updateGradient();
  }

  private updateInterpolatedColor(): void {
    this.interpolatedColor = this.getGradientColorAtProgress(this.progress);
  }

  private getGradientColorAtProgress(progress: number): string {
    const clamped = Math.max(0, Math.min(100, progress));
    const stops = this.gradientStops;

    if (clamped <= stops[0].offset) return stops[0].color;
    if (clamped >= stops[stops.length - 1].offset) return stops[stops.length - 1].color;

    for (let i = 0; i < stops.length - 1; i++) {
      const start = stops[i];
      const end = stops[i + 1];

      if (clamped >= start.offset && clamped <= end.offset) {
        const factor = (clamped - start.offset) / (end.offset - start.offset);
        return this.interpolateColor(start.color, end.color, factor);
      }
    }

    return '#FF0000'; // Fallback
  }

  private interpolateColor(color1: string, color2: string, factor: number): string {
    const c1 = color1.slice(1).match(/.{2}/g)!.map(hex => parseInt(hex, 16));
    const c2 = color2.slice(1).match(/.{2}/g)!.map(hex => parseInt(hex, 16));

    const interpolated = c1.map((c, i) =>
      Math.round(c + factor * (c2[i] - c)).toString(16).padStart(2, '0')
    );

    return `#${interpolated.join('')}`;
  }

  updateGradient(): void {
    const path = this.progressPath?.nativeElement;
    const shadow = this.shadowPath?.nativeElement;

    if (!path || !shadow) return;

    const radius = 34;
    const arcLength = Math.PI * radius;
    const ratio = Math.max(0, Math.min(1, this.progress / 100));

    path.setAttribute('stroke-width', `12`);
    path.setAttribute('stroke-dasharray', `${arcLength}`);
    path.setAttribute('stroke-dashoffset', `${arcLength * (1 - ratio)}`);
  }

  get showReliabilityLabel(): boolean {
  return this.initProgress < 0 || this.progress > 0 || 
         (this.initProgress === 0 && this.staffer?.['shifts_completed'] > 0);
}

get showUnratedLabel(): boolean {
  return this.staffer?.['shifts_completed'] === 0 && 
         (this.initProgress == null || this.initProgress === 0);
}

}
